import axios from 'axios'

export const getData = ({ commit }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-kapendik/" + payload.jensek_id+ "/" + payload.tajar_id)
            .then((response) => {
                commit('SET_EVENTS', response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve(response.data)
            })
            .catch((errors) => {
                reject('fail')
            });
    })
}


export const storeKapendik = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama_event;
    return new Promise((resolve, reject) => {
        axios.post("/api/store-kapendik", payload).then((response) => {
            let notif = {
                msg: nama + " Berhasil ditambahkan~",
                type: "create"
            }
            commit("SET_NOTIF", notif, { root: true });
            let temp = {
                jensek_id: payload.jensek_id,
                tajar_id: payload.tajar_id
            }
            dispatch("getData", temp);
            resolve("ok")
        }).catch((e) => {
            commit("SET_OVERLAY", false, { root: true });
            reject(e.response.data.errors)
        });
    })
}

export const updateKapendik = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama_event;
    let formData = {};
    let arr = ['id', 'jensek_id', 'tajar_id','created_at', 'updated_at', 'event_date_text'];
    for (const [key, value] of Object.entries(payload)) {
        if (!arr.includes(key)) {
            formData[key] = value
        }
    }
    return new Promise((resolve, reject) => {
        axios.put("/api/update-kapendik/"+payload.id, formData).then((response) => {
            let notif = {
                msg: nama + " Berhasil diupdate~",
                type: "update"
            }
            commit("SET_NOTIF", notif, { root: true });
            let temp = {
                jensek_id: payload.jensek_id,
                tajar_id: payload.tajar_id
            }
            dispatch("getData", temp);
            resolve("ok")
        }).catch((e) => {
            commit("SET_OVERLAY", false, { root: true });
            reject(e.response.data.errors)
        });
    })
}

export const deleteKapendik = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama_event;
    return new Promise((resolve, reject) => {
        axios.delete("/api/delete-kapendik/" + payload.id).then((response) => {
            let notif = {
                msg: nama + " Berhasil dihapus~",
                type: "delete"
            }
            let temp = {
                jensek_id: payload.jensek_id,
                tajar_id: payload.tajar_id
            }
            dispatch("getData", temp).then(() => {
                commit("SET_NOTIF", notif, { root: true });
            });
            resolve("ok")
        }).catch((e) => {
            commit("SET_OVERLAY", false, { root: true });
            reject("fail")
        });
    })
}